module.exports = __webpack_public_path__ + "static/media/Heliolisk_gaussian2.499d951a.png";